import {BaseEntity} from "@betrue/shared/interfaces";

export const randomEnum = <T>(anEnum: T): T[keyof T] => {
  const enumValues = Object.keys(anEnum)
    .map(n => Number.parseInt(n))
    .filter(n => !Number.isNaN(n)) as unknown as T[keyof T][]
  const randomIndex = Math.floor(Math.random() * enumValues.length)
  const randomEnumValue = enumValues[randomIndex]
  return randomEnumValue;
}

export const randomData = <T extends BaseEntity>(dataset: T[], quantity: number) => {
   let array = Array.from(Array(quantity)).map((i) => {
   const randomItem = dataset[Math.floor(Math.random() * dataset.length)]
   dataset = dataset.filter((it => it.id !== randomItem.id))
   return randomItem
 })
  return array}



